import React from "react";
import { connect } from "react-redux";
import { toggleMenu } from "../../Redux/actions";
import "./Navbar.css";

const Navbar = (props, { toggleMenu }) => {
  return (
    <div className="container">
      <div className="logoHolder">
        <a href="/" className="logoWrapper">
          logo
        </a>
      </div>

      <div className="menuBox">
        <p className={props.toggleClass === false ? "Mup" : null}>M</p>
        <div className="menu-btn" onClick={props.toggleMenu}>
          <div className="aboutButton">
            <span
              className={
                props.toggleClass === false
                  ? "menu-btn__button"
                  : "menu-btn__button open"
              }
            />
          </div>
        </div>
        <p className={props.toggleClass === false ? "UNup" : null}>N</p>
        <p className={props.toggleClass === false ? "UNup" : null}>U</p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    toggleClass: state.menu.burgerMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
